import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project, index = 0 }) => {
    return (
        <Link
            to={`/projekter/${project.slug}`}
            data-testid="project-card"
            className="group block"
        >
            <div className="img-hover aspect-[4/5] bg-[#EAE3D5] overflow-hidden rounded-sm mb-5">
                <img
                    src={project.cover}
                    alt={project.title}
                    loading={index < 2 ? "eager" : "lazy"}
                    className="w-full h-full object-cover"
                />
            </div>
            <div className="flex items-start justify-between gap-6">
                <div>
                    <div className="overline mb-2">
                        {project.category} · {project.year}
                    </div>
                    <h3 className="font-serif text-2xl md:text-[1.75rem] leading-tight text-[#2C241B] group-hover:text-[#2F483A] transition-colors">
                        {project.title}
                    </h3>
                    {project.subtitle && (
                        <p className="text-sm text-[#7A6855] mt-2">
                            {project.subtitle}
                        </p>
                    )}
                </div>
                <ArrowUpRight
                    size={22}
                    className="mt-2 text-[#8B5E3C] transition-transform duration-500 group-hover:-translate-y-1 group-hover:translate-x-1 shrink-0"
                />
            </div>
        </Link>
    );
};

export default ProjectCard;
